import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AgreementForm, AgreementFormModel } from '@app/root/components/agreement/agreement.form';
import { LoginLayoutComponent } from '@app/root/components/login-layout/login-layout.component';
import { FormlyModule } from '@ngx-formly/core';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { ChitinButtonComponent } from '@shared/components/chitin/atoms/button/button.component';
import { createFormGroup, getDirtyValues } from '@shared/components/forms/form';
import { AgreementType } from '@shared/models/agreement-type.enum';
import { omit } from 'lodash';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  imports: [LoginLayoutComponent, FormlyModule, ReactiveFormsModule, ChitinButtonComponent],
})
export class AgreementComponent {
  private authService = inject(AuthService);
  private userService = inject(UserService);

  form = createFormGroup<AgreementFormModel>();
  formFields = AgreementForm();
  currentUser = this.userService.currentUser;
  error = signal('');
  isSending = signal(false);

  constructor() {
    const user = this.currentUser();
    if (user && this.userService.hasAcceptedAgreements(user)) {
      this.authService.redirectToStartingPage();
    }
  }

  onSubmit() {
    this.form.markAllAsTouched();
    const user = this.currentUser();
    if (!user || this.form.invalid) return;
    this.isSending.set(true);
    this.error.set('');
    const { acceptedAgreements } = this.userService.acceptAgreement(user, AgreementType.USER_PHARMACY_OWNER);
    const changes = omit(getDirtyValues<AgreementFormModel>(this.form), 'termsAccepted');
    this.userService.updateCurrentUser({ ...changes, username: user.username, acceptedAgreements }).subscribe(result => {
      this.isSending.set(false);
      if (!result) {
        this.error.set('Failed to update user agreement');
      } else {
        this.authService.redirectToStartingPage();
      }
    });
  }
}
